import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";

const Committee = () => {
  const [index, setIndex] = useState(0);

  return (
    <div className='main-container'>
      <ul id='leadershipNav'>
        <Link
          to='audit-committee'
          onClick={() => {
            setIndex(0);
          }}
        >
          <li className={`list-item ${index === 0 ? "active" : ""}`}>
            Audit Committee
          </li>
        </Link>
        <Link
          to='corporate-governance'
          onClick={() => {
            setIndex(1);
          }}
        >
          <li className={`list-item ${index === 1 ? "active" : ""}`}>
            Corporate Governance Committee
          </li>
        </Link>
        <Link
          to='board-risk-oversight'
          onClick={() => {
            setIndex(2);
          }}
        >
          <li className={`list-item ${index === 2 ? "active" : ""}`}>
            Board Risk Oversight Committee
          </li>
        </Link>
        <Link
          to='related-party-transactions'
          onClick={() => {
            setIndex(3);
          }}
        >
          <li className={`list-item ${index === 3 ? "active" : ""}`}>
            Related Party Transactions Committee
          </li>
        </Link>
      </ul>
      <div className='description'>
        <Outlet />
      </div>
    </div>
  );
};

export default Committee;
